import type { MenuGroup } from '@/core/layout/menuConfig';
import {
  adminMenu,
  counselorMenu,
  parentMenu,
  royalOverseasMenu,
} from '@/core/layout/menuConfig';

const ALL_MENU_GROUPS: MenuGroup[][] = [adminMenu, parentMenu, counselorMenu, royalOverseasMenu];

/** Resolve the best menu label for a pathname (longest prefix match). */
export function resolvePageTitle(pathname: string): string | null {
  const normalized = pathname.replace(/\/$/, '') || '/';
  let best: { path: string; title: string } | null = null;

  for (const menus of ALL_MENU_GROUPS) {
    for (const group of menus) {
      for (const section of group.Items) {
        if (section.path) {
          if (matchesPath(normalized, section.path)) {
            if (!best || section.path.length > best.path.length) {
              best = { path: section.path, title: section.title };
            }
          }
        }
        for (const child of section.children ?? []) {
          if (matchesPath(normalized, child.path)) {
            if (!best || child.path.length > best.path.length) {
              best = { path: child.path, title: child.title };
            }
          }
        }
      }
    }
  }

  return best?.title ?? null;
}

function matchesPath(pathname: string, menuPath: string): boolean {
  return pathname === menuPath || pathname.startsWith(`${menuPath}/`);
}

/** Human-readable titles for routes not in the sidebar menu. */
const EXTRA_TITLES: Record<string, string> = {
  '/account': 'My Profile',
  '/admin/users': 'User Management',
  '/admin/users/roles': 'Roles & Permissions',
  '/royal-overseas/users/roles': 'Roles & Permissions',
  '/admin/students': 'Student Management',
  '/admin/guardians': 'Guardian Management',
  '/admin/academics/subjects': 'Subject Management',
  '/royal-overseas/schools': 'Schools',
};

export function resolvePageVisitMessage(pathname: string): string | null {
  const normalized = pathname.replace(/\/$/, '') || '/';

  for (const [path, title] of Object.entries(EXTRA_TITLES)) {
    if (matchesPath(normalized, path)) {
      return title;
    }
  }

  const fromMenu = resolvePageTitle(pathname);
  return fromMenu;
}
